import { Tooltip } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useState } from "react";
import { useGetSafraConsultoria } from "../../../../../../../../services/Safra/GET";
import { InfoAdicionais } from "../infoAdicionais";
import { VisualizarInconsistencia } from "../visualizarInconsistencia";
import { obterEstadoAlerta } from "./meta/estadoAlerta";

//PROPS
interface Props {
    resultado_inconsistente: number;
    observacao: string;
    cod_safra_conta: number;
    laboratorio_nome: string;
    /** Cliente dono da OS, exibido nas informações adicionais. */
    cliente_nome?: string;
    cod_calcario: number;
    cod_calcario_propriedade: number;
    /** Status da OS: 6/7 (inconsistência) e 8 (resultado com erro) também
     *  disparam o alerta, além de `resultado_inconsistente`. */
    status?: number;
}

export const IconeAlerta: React.FC<Props> = ({ resultado_inconsistente, observacao, cod_safra_conta, laboratorio_nome,
    cod_calcario, cod_calcario_propriedade, status, cliente_nome
}) => {

    //#region STATES
    const [abrirInconsistencia, setAbrirInconsistencia] = useState<boolean>(false);
    const [textoInconsistencia, setTextoInconsistencia] = useState<string>('');

    //#API
    const { data_safras, carregando_safras } = useGetSafraConsultoria();

    // Estado ÚNICO da linha — o mesmo objeto alimenta o ícone e o tooltip.
    const estado = obterEstadoAlerta({
        resultado_inconsistente, status, cod_calcario, cod_calcario_propriedade,
    });

    return (
        <>
        <Tooltip
            trigger='hover'
            placement='right'
            color='#fff'
            overlayInnerStyle={{
                color: '#000',
                padding: 12,
                borderRadius: 8,
                minWidth: estado.alertar ? '350px' : '220px',
            }}
            title={
                <InfoAdicionais
                    estado={estado}
                    dataSafraConsultoria={data_safras}
                    cod_safra_conta={cod_safra_conta}
                    laboratorio_nome={laboratorio_nome}
                    cliente_nome={cliente_nome}
                    chamarModalInconsistencia={() => {
                        setAbrirInconsistencia(true)
                        setTextoInconsistencia(observacao)
                    }}
                />
            }
        >
            <div
                style={{
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <FontAwesomeIcon
                    icon={estado.icone}
                    style={{
                        fontSize: 18,
                        color: estado.cor,
                        cursor: 'pointer',
                    }}
                />
            </div>
        </Tooltip>

        <VisualizarInconsistencia
            abrir={abrirInconsistencia}
            setAbrir={setAbrirInconsistencia}
            texto={textoInconsistencia}
        />
        </>
    )
}
